import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'//React routes
import Parser from 'html-react-parser';
import {
    Typography,
    TableContainer,
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableHead,
    Button,
    List,
    SwipeableDrawer,
    FormControl,
    FormControlLabel,
    RadioGroup,
    Radio,useTheme
} from '@mui/material'
// import {
//     mainStyles,//Estílos genéricos
// } from '../../styles'//Se importan los estilos genéricos
import {
    InputField,
    CustomCounterAppBar,
    ListElement, CustomLoadingOverlay
,Buttons } from '../../components'
import { certificateActions, fileActions } from '../../store/actions'//Acciones para redux
// import { useStyles } from './FirmaEAFormStyles' // './FirmaEAFormStyles'//Estílos específicos de los elementos de este componente

import { useTranslation } from 'react-i18next';

export default function FirmaEAFormComponent(props) {
    const { useState, useEffect, useRef } = React//Hook para el state
    const gridContainer = {} //mainStyles.gridStyle()
     const theme = useTheme()
    const location = useLocation()
  const classes = {} //mainStyles.bodyStyles()//estílos genéricos (Main.js)
    // const gridContainer = {} //mainStyles.gridStyle()
    const localStyles = {}//useStyles()//estílos de este componente (LoginStyles.js)
    const navigate = useNavigate()//Módulo "History" de react router

    const [loadView, setLoadView] = useState(false)
    const [alertType, setAlertType] = useState("")
    const [message, setMessage] = useState("")
    const [fileView, setFileView] = useState("")
    const [document, setDocument] = useState('')
    const [showPass, setShowPass] = useState(false)//State para mostrar u ocultar contraseña
    const [ActiveAuth, setActiveAuth] = useState(false)
    const [ActiveDocument, setActiveDocument] = useState(false)
    const [initLoad, setInitLoad] = useState(false)
    const [currentStage, setCurrentStage] = useState(0)
    const [totalStage, setTotalStage] = useState(0)

    const [txtPasswordEF, setTxtPasswordEF] = useState('')
    const [signingType, setSigningType] = useState(1)
    const [signedDocument, setSignedDocument] = useState(false)
    const [txtCer, setTxtCer] = useState('')
    const [txtKey, setTxtKey] = useState('')
    const [txtCerB64, setTxtCerB64] = useState('')
    const [txtKeyB64, setTxtKeyB64] = useState('')
    const [activeButton, setActiveButton] = useState(false)
    const [activeFEA, setActiveFEA] = useState(true)
    const [activeEDICOM, setActiveEDICOM] = useState(false)
    const [txtUser, setTxtUser] = useState('')
    const [txtPassECM, setTxtPassECM] = useState('')
    const [txtSerial, setTxtSerial] = useState('')
    const [sendRegisterEDICOM, setSendRegisterEDICOM] = useState(false)
    const [messageSigning, setMessageSigning] = useState('')
    const [optionsCombo, setOptionsCombo] = useState([{ Option: 'SAT', Value: 1 }, { Option: 'EDICOM', Value: 2 }])
    const [signingActive, setSigningActive] = useState(false)

    const cerFileLoader = useRef(null) //new
    const keyFileLoader = useRef(null) //new

    const { t } = useTranslation();

    //Redux hooks
    const auth = useSelector(state => state.Authentication)
    const cerificate = useSelector(state => state.RegisterCertificate)
    const documetCertificate = useSelector(state => state.DocumentCertificate)
    const file = useSelector(state => state.FileInfo)

    const dispatch = useDispatch()

    //Promesa general Init
    useEffect(() => {
        let fileId = location.state.folioId
        dispatch(fileActions.GetFileInfo(fileId))
        setInitLoad(true)
    }, [])

    useEffect(() => {
        setLoadView(cerificate.loading)
        if (file.items != null && file.items != undefined && initLoad) {
            // dispatch(certificateActions.GetDocumentCertificate())
            // setInitLoad(false)
            // setActiveDocument(true)
            setCurrentStage(file.items.Stage.CurrentStageGroup)
            setTotalStage(file.items.Stage.TotalStageGroups)
        } else if (auth.error != null && auth.error != undefined && initLoad) {
            setInitLoad(false)
            console.log("Authentication: Error: ", auth)
            alert(auth.error)
        }
    }, [file])

    useEffect(() => {
        // console.log("cerificate", cerificate.items)
        setLoadView(cerificate.loading)
        if (cerificate.items != undefined && sendRegisterEDICOM) {
            setSendRegisterEDICOM(false)
            clear()
            if (cerificate.items.CreationDate != null) {
                let date = new Date(cerificate.items.CreationDate);
                let messageFormat = "Estatus de firma: <span style='color:#28A745' >Firma establecida.</span>  <span style='color:#898B8D' >" + getDayName(date) + " " + date.toLocaleDateString() + " " + date.toLocaleTimeString() + " hrs</span> "
                console.log("messageFormat: ", messageFormat)
                setMessageSigning(messageFormat)
                setSignedDocument(true)
                setActiveAuth(false)
                setSigningActive(true)
            }
            setFileView(`data:application/pdf;base64,${cerificate.items.B64Content}`)
            // console.log("cerificate.B64Content", items.B64Content)
        } else if (cerificate.error != undefined && sendRegisterEDICOM) {
            setAlertType("alert-danger")
            setMessage(cerificate.error)
            setSendRegisterEDICOM(false)
            setActiveAuth(false)
        }
    }, [cerificate])

    useEffect(() => {
        console.log("documetCertificate:", documetCertificate)
        setLoadView(documetCertificate.loading)
        if (documetCertificate.items != undefined && ActiveDocument) {
            setSendRegisterEDICOM(false)
            clear()
            if (documetCertificate.items.CreationDate != null) {
                let date = new Date(documetCertificate.items.CreationDate);
                let messageFormat = "Estatus de firma: <span style='color:#28A745' >Firma establecida.</span>  <span style='color:#898B8D' >" + getDayName(date) + " " + date.toLocaleDateString() + " " + date.toLocaleTimeString() + " hrs</span> "
                console.log("messageFormat: ", messageFormat)
                setMessageSigning(messageFormat)
                setSignedDocument(true)
                setActiveDocument(false)
                setSigningActive(true)
            }
            setFileView(`data:application/pdf;base64,${documetCertificate.items.B64Content}`)
        } else if (documetCertificate.error != undefined && ActiveDocument) {
            setAlertType("alert-danger")
            setMessage(documetCertificate.error)
            setSendRegisterEDICOM(false)
            setActiveDocument(false)
        }
    }, [documetCertificate])

    let getDayName = (date) => {
        const numeroDia = date.getDay();
        switch (numeroDia) {
            case 1:
                return 'Lunes'
            case 2:
                return 'Martes'
            case 3:
                return 'Miercoles'
            case 4:
                return 'Jueves'
            case 5:
                return 'Viernes'
            case 6:
                return 'Sabado'
            case 7:
                return 'Domingo'
            default:
                return 'Lunes'
        }
    }

    let eventAttachFile = (e) => {
        let idCtrl = (e.target.id === '' ? e.target.parentNode.id : e.target.id)
        switch (idCtrl) {
            case 'btnCer':
                appendCerOrKeyFile('.cer')
                console.log("document", document)
                break;
            case 'btnKey':
                appendCerOrKeyFile('.key')
                break;
        }
    }

    let getCerOrKeyFileLoaded = (event) => {
        if (event.target.files && event.target.files[0]) {
            let name = event.target.files[0].name
            let readerToSend = new FileReader()
            readerToSend.onload = (e) => {
                turnTob64(e, name)
            }
            readerToSend.readAsDataURL(event.target.files[0]); //this is to read as b64   
        }
    }

    const turnTob64 = (e, event) => {
        let ext = event.slice((event.lastIndexOf(".") - 1 >>> 0) + 2);

        let base64 = e.target.result
        base64 = base64.split(',')
        console.log("e: e.base64", base64)
        setDocument(base64[1])

        if (ext.toLowerCase() === 'cer') {
            setTxtCer(event)
            setTxtCerB64(base64[1])
        }
        else if (ext.toLowerCase() === 'key') {
            setTxtKey(event)
            setTxtKeyB64(base64[1])
        }
    }

    const appendCerOrKeyFile = (file) => {
        setSignedDocument(false)
        if (file === '.cer') {
            cerFileLoader.current.click()
        } else if (file === '.key') {
            keyFileLoader.current.click()
        }
    }

    let handleFields = (e) => {//almacenar usuario y contraseña en state
        setSignedDocument(false)
        switch (e.target.name) {
            case 'txtPasswordEF':
                setTxtPasswordEF(e.target.value)//Setear state del usuario  
                if (txtCerB64 != '' && txtKeyB64 != '' && e.target.value != '' && signingType != '') {
                    setActiveButton(true)
                }
                break;
            case 'cmbTypeFirm':
                setSigningType(e.target.value)
                if (e.target.value === 1) {
                    setActiveFEA(true)
                    setActiveEDICOM(false)
                    setActiveButton(false)
                    setSigningActive(false)
                    clear()
                } else if (e.target.value === 2) {
                    setActiveEDICOM(true)
                    setActiveFEA(false)
                    setActiveButton(false)
                    setSigningActive(false)
                    clear()
                }
                break;
            case 'txtUser':
                setTxtUser(e.target.value)
                if (txtPassECM != '' && txtSerial != '' && e.target.value != '' && signingType != '') {
                    setActiveButton(true)
                }
                break;
            case 'txtPassECM':
                setTxtPassECM(e.target.value)
                if (txtUser != '' && txtSerial != '' && e.target.value != '' && signingType != '') {
                    setActiveButton(true)
                }
                break;
            case 'txtSerial':
                setTxtSerial(e.target.value)
                if (txtUser != '' && txtPassECM != '' && e.target.value != '' && signingType != '') {
                    setActiveButton(true)
                }
                break;
            default:
        }
    }

    let clear = () => {
        setTxtPassECM("")
        setTxtUser("")
        setTxtSerial("")
        setAlertType("")
        setMessage("")
        setTxtCerB64("")
        setTxtKeyB64("")
        setTxtKey("")
        setTxtCer("")
        setTxtPasswordEF("")
        setAlertType("")
        setMessage("")
    }

    let submitEventFEA = (e) => {//Login        
        e.preventDefault()
        let params = {
            CertificateData: {
                CertCerB64: txtCerB64,
                CertKeyB64: txtKeyB64,
                CertPwd: txtPasswordEF
            },
            B64Content: "",
            Reference: 'ref FEA: ' + txtPasswordEF
        }
        console.log("submitEventFEA: request", params)
        setSendRegisterEDICOM(true)
        // dispatch(certificateActions.RegisterCertificateType02(params))       
    }

    let submitEventEDM = (e) => {
        setAlertType("")
        setMessage("")
        let params = {
            CertificateData: {
                CertUsr: txtUser,
                CertPwd: txtPassECM,
                CertSerial: txtSerial
            },
            B64Content: "",
            Reference: 'ref EDICOM: ' + txtUser
        }

        console.log("submitEventEDM: request", params)
        setSendRegisterEDICOM(true)
        // dispatch(certificateActions.RegisterCertificateType01(params))
    }

    const setCerofKeyValue = (list, uploaded, name) => {
        // setAskFile(true)
        // setDocumentId(list[0].Id)
        // setSectionId(list[0].Sections[0].Id)
        // setOcrInfo(cargarDocsFunctions.getOcrValue(list[0].Properties))
        // if (name === '.CER' && uploaded === 'no') {
        //   setExt('.cer')
        //   appendCerOrKeyFile('.cer')
        // } else if (name === '.KEY' && uploaded === 'no') {
        //   setExt('.key')
        //   appendCerOrKeyFile('.key')
        // } else if (name === '.CER' && uploaded === 'yes') {
        //   setExt('.cer')
        //   setCapturedDocAlert(true)
        // } else if (name === '.KEY' && uploaded === 'yes') {
        //   setExt('.key')
        //   setCapturedDocAlert(true)
        // }

    }

    //Comienza interfaz
    return (<div className={gridContainer.container}>
        <div className={gridContainer.leftColumn}></div>
        <div className={gridContainer.centerColumn}>
            <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
            {/* {loadView ? <LoadingOverlay
                active={loadView}
                spinner
                text='Espere un momento por favor...'
                className={classes.loader}>
            </LoadingOverlay> : null} */}
            <CustomCounterAppBar
                initialStep={currentStage}
                endingStep={totalStage} />
            {alertType != undefined && alertType != '' &&
                alert(message)
            }
            <div className={gridContainer.centerContent1}>

                <input id="aCer" name="aCer" type="file" hidden ref={cerFileLoader}
                    accept=".cer, application/pkix-cert, .cert" onChange={getCerOrKeyFileLoaded} />

                <input id="aKey" name="aKey" type="file" hidden ref={keyFileLoader}
                    accept=".key" onChange={getCerOrKeyFileLoaded} />

                <Typography variant="h6"
                    gutterBottom
                    
          >
                    {t("advanced_electronic_signature")}
                </Typography>
                <Typography variant="subtitle1"
                    gutterBottom
                    className={localStyles.subTitleCalculate}>{t("required_field")} (*).</Typography>
                <TableContainer>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell align="left" style={{
                                    borderBottom: "none",
                                    paddingBottom: 10,
                                }} padding="none"
                                    className={localStyles.names}>
                                    <Typography variant="subtitle1">{t("business_name")}</Typography>
                                </TableCell>
                                <TableCell align="left" style={{
                                    borderBottom: "none",
                                    paddingBottom: 10,
                                }} padding="none"
                                    className={localStyles.names}>
                                    <Typography variant="subtitle1">{t("value")}</Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="left" style={{
                                    borderBottom: "none",
                                    paddingBottom: 10,
                                }} padding="none"
                                    className={localStyles.names}>
                                    <Typography variant="subtitle1">{t("rfc")}</Typography>
                                </TableCell>
                                <TableCell align="left" style={{
                                    borderBottom: "none",
                                    paddingBottom: 10,
                                }} padding="none"
                                    className={localStyles.names}>
                                    <Typography variant="subtitle1">{t("value")}</Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <Typography variant="h6" gutterBottom className={localStyles.title}>
                    {t("select_signature_files")}
                </Typography>
                <List
                    component="nav"
                    aria-label="secondary mailbox folders"
                    className={localStyles.rootList}>
                    <Button className={gridContainer.buttonList}
                        key={`btnCer`}
                        onClick={() => setCerofKeyValue("btnCer", 'yes', "btnCer")} >
                        <ListElement
                            key={`list_element_key_cer`}
                            keyProps='txtCer'
                            capture={true}
                            text={`$KEY*`}
                            statusColor={1}
                            status='Capturado'
                            description="KEY DESC" />
                    </Button>
                    <Button className={gridContainer.buttonList}
                        key={`btnCer`}
                        onClick={() => setCerofKeyValue("btnCer", 'yes', "btnCer")} >
                        <ListElement
                            key={`list_element_key_cer`}
                            keyProps='txtCer'
                            capture={true}
                            text={`CER*`}
                            statusColor={1}
                            status='Capturado'
                            description="CER DESK" />
                    </Button>
                </List>

                <div className={localStyles.rowContent}>
                    <div className={localStyles.Column1} >
                        <InputField
                            className={localStyles.root}
                            id='txtCer'
                            name='txtCer'
                            label='.cer'
                            variant='outlined'
                            value={txtCer}
                            required={true}
                            disabled={true}
                            textTransform="none"
                            size="small"
                            type="TextControl"
                            iconLabel='LockRounded'
                        />
                    </div>
                    <div className={localStyles.Column2} >
                        <InputField
                            className={localStyles.root}
                            id='btnCer'
                            name='btnCer'
                            size={90}
                            disabled={signingActive}
                            backgroundColor={signingActive ? '#898B8D' : '#C20E30'}
                            textColor='#FFFFFF'
                            text='Adjuntar'
                            fontSize={10}
                            click={eventAttachFile}
                            startIcon='AttachFile'
                            type='ButtonControl'
                        />
                    </div>
                </div>
                <div className={localStyles.rowContent}>
                    <div className={localStyles.Column1} >
                        <InputField
                            className={localStyles.root}
                            id='txtKey'
                            name='txtKey'
                            label='.key'
                            variant='outlined'
                            value={txtKey}
                            required={true}
                            disabled={true}
                            textTransform="none"
                            size="small"
                            type="TextControl"
                            iconLabel='VpnKeyRounded'
                        />
                    </div>
                    <div className={localStyles.Column2} >
                        <InputField
                            className={localStyles.root}
                            id='btnKey'
                            name='btnKey'
                            size={90}
                            disabled={signingActive}
                            backgroundColor={signingActive ? '#898B8D' : '#C20E30'}
                            textColor='#FFFFFF'
                            text='Adjuntar'
                            fontSize={10}
                            click={eventAttachFile}
                            startIcon='AttachFile'
                            type='ButtonControl'
                        />
                    </div>
                </div>
                <div className={localStyles.rowContent}>
                    <div className={localStyles.Column1} >
                        <InputField
                            className={localStyles.root}
                            id='txtPasswordEF'
                            name='txtPasswordEF'
                            label='Contraseña'
                            variant='outlined'
                            onChange={handleFields}
                            value={txtPasswordEF}
                            required={true}
                            disabled={signingActive}
                            textTransform="none"
                            size="small"
                            type="Password"
                        />
                    </div>
                    <div className={localStyles.Column2} >
                    </div>
                </div>
                <div className={localStyles.rowContent}>
                    <div className={localStyles.Column1} >
                        <InputField
                            className={activeButton ? localStyles.ButtonActive : localStyles.ButtonDisabled}
                            id='btnFirmar'
                            name='btnFirmar'
                            disabled={signingActive}
                            size={100}
                            backgroundColor={activeButton ? '#C20E30' : '#898B8D'}
                            textColor='#FFFFFF'
                            text='Firmar'
                            fontSize={11}
                            click={submitEventFEA}
                            startIcon='BorderColor'
                            type='ButtonControl'
                        />
                    </div>
                    <div className={localStyles.Column2} >
                    </div>
                </div>
            </div>
        </div>
        <div className={gridContainer.rightColumn}></div>
    </div>
    )
}
